export type Address = {
  countryCode: 'BE'
  postalCode: string
  townCode: number
  townName: string
  streetName: string
  streetNumber: string
  streetBox?: string
}

export type FuelPricelistUrls = {
  electricity: string
  gas: string
}

// ENUMS

export enum WarmProspectFlow {
  FESTIVAL = 'festival',
  NEWSLETTER = 'newsletter'
}
